import { EditAssignmentData, ModalsSlice, PlannerSliceCreator } from '../types';

/** Modal state: edit/delete assignment payloads and the overlap/unavailable warnings. */
export const createModalsSlice: PlannerSliceCreator<ModalsSlice> = set => ({
  editAssignmentData: null,
  setEditAssignmentData: (data: EditAssignmentData) => set({ editAssignmentData: data }),
  resetEditAssignment: () => set({ editAssignmentData: null }),

  showOverlapWarning: false,
  setShowOverlapWarning: (show: boolean) => set({ showOverlapWarning: show }),

  showUnavailableWarning: false,
  setShowUnavailableWarning: (show: boolean) => set({ showUnavailableWarning: show }),

  deleteAssignmentData: null,
  setDeleteAssignmentData: (data: { id: number; userName?: string; projectName?: string } | null) =>
    set({ deleteAssignmentData: data }),
});
